import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

export const useFeatureFlags = () => {
  const page = usePage()

  const COACHING_ENABLED = computed(
    () => page.props.shared.featureFlags.coachingEnabled,
  )
  const HELP_REQUESTS_VOTING_ENABLED = computed(
    () => page.props.shared.featureFlags.helpRequestsVotingEnabled,
  )
  const ROADMAP_FIRST_ONBOARDING_ENABLED = computed(
    () => page.props.shared.featureFlags.roadmapFirstOnboardingEnabled,
  )
  const SESSION_PREP_AND_TAKEAWAYS_ENABLED = computed(
    () => page.props.shared.featureFlags.sessionPrepAndTakeawaysEnabled,
  )
  // Takeaways for the member: the sidebar row, the home card and the page.
  // The server sets it only with SESSION_PREP_AND_TAKEAWAYS_ENABLED on.
  const TAKEAWAYS_ENABLED = computed(
    () => !!page.props.shared.featureFlags.takeawaysEnabled,
  )
  const VOICE_NOTES_ENABLED = computed(
    () => page.props.shared.featureFlags.voiceNotesEnabled,
  )
  const CITY_SQUADS_ENABLED = computed(
    () => page.props.shared.featureFlags.citySquadsEnabled,
  )
  const ASK_ENABLED = computed(() => page.props.shared.featureFlags.askEnabled)
  const ASKS_ENABLED = computed(
    () => page.props.shared.featureFlags.asksEnabled,
  )
  const WORK_ENABLED = computed(
    () => page.props.shared.featureFlags.workEnabled,
  )
  const ADVENTURES_ENABLED = computed(
    () => !!page.props.shared.featureFlags.adventuresEnabled,
  )
  const STARTUP_PAGES_ENABLED = computed(
    () => page.props.shared.featureFlags.startupPagesEnabled,
  )
  const INSIDERS_TOOLS_ENABLED = computed(
    () => page.props.shared.featureFlags.insidersToolsEnabled,
  )
  // True when any Community tab besides People is open. Drives the nav item
  // and the Community header; the server derives it from the tab flags.
  const COMMUNITY_SHELL_ENABLED = computed(
    () => page.props.shared.featureFlags.communityShellEnabled,
  )
  const SIDEBAR_NAV_ENABLED = computed(
    () => !!page.props.shared.featureFlags.sidebarNavEnabled,
  )
  const MENTOR_STATS_ENABLED = computed(
    () => !!page.props.shared.featureFlags.mentorStatsEnabled,
  )
  const HELP_REQUEST_SUMMARIES_ENABLED = computed(
    () => !!page.props.shared.featureFlags.helpRequestSummariesEnabled,
  )
  const CHAT_LINKED_CARDS_ENABLED = computed(
    () => !!page.props.shared.featureFlags.chatLinkedCardsEnabled,
  )
  // The mentor chat at /ai-matching. On: the chat is the page that finds
  // mentors, and the doors of the Roadmap builder open the chat.
  const MENTOR_CHAT_ENABLED = computed(
    () => !!page.props.shared.featureFlags.mentorChatEnabled,
  )
  // A visitor's Request a Call (a chat card or a mentor profile) opens the
  // account pop-up with the slides: real calls, unlimited calls, the faces.
  const CHAT_AFTER_SIGNUP_ENABLED = computed(
    () => !!page.props.shared.featureFlags.chatAfterSignupEnabled,
  )
  // The new mentee experience: the path on Direction, no profile step and no
  // minimum on a request, the session page with the tour after a request.
  const NEW_MENTEE_EXPERIENCE_ENABLED = computed(
    () => !!page.props.shared.featureFlags.newMenteeExperienceEnabled,
  )
  const MEMBER_MCP_ENABLED = computed(
    () => !!page.props.shared.featureFlags.memberMcpEnabled,
  )
  const DEVELOPER_DOCS_ENABLED = computed(
    () => !!page.props.shared.featureFlags.developerDocsEnabled,
  )
  // With MEMBER_MCP_ENABLED: the Memory export window shows how to connect
  // an AI tool.
  const MEMORY_EXPORT_CONNECT_ENABLED = computed(
    () => !!page.props.shared.featureFlags.memoryExportConnectEnabled,
  )

  return {
    COACHING_ENABLED,
    HELP_REQUESTS_VOTING_ENABLED,
    ROADMAP_FIRST_ONBOARDING_ENABLED,
    SESSION_PREP_AND_TAKEAWAYS_ENABLED,
    TAKEAWAYS_ENABLED,
    VOICE_NOTES_ENABLED,
    CITY_SQUADS_ENABLED,
    ASK_ENABLED,
    ASKS_ENABLED,
    WORK_ENABLED,
    ADVENTURES_ENABLED,
    STARTUP_PAGES_ENABLED,
    INSIDERS_TOOLS_ENABLED,
    COMMUNITY_SHELL_ENABLED,
    SIDEBAR_NAV_ENABLED,
    MENTOR_STATS_ENABLED,
    HELP_REQUEST_SUMMARIES_ENABLED,
    CHAT_LINKED_CARDS_ENABLED,
    MENTOR_CHAT_ENABLED,
    CHAT_AFTER_SIGNUP_ENABLED,
    NEW_MENTEE_EXPERIENCE_ENABLED,
    MEMBER_MCP_ENABLED,
    DEVELOPER_DOCS_ENABLED,
    MEMORY_EXPORT_CONNECT_ENABLED,
  }
}
